import axios from "axios";
import getBaseEndpoint from "./config";
import { setGlobalLoading } from "../../redux/features/globalUtilitySlice";
import ReduxStore from "../../redux/store";

const axiosInstance = axios.create({
  baseURL: getBaseEndpoint(),
  withCredentials: false, // ✅ no cookies / no auth tokens
  timeout: 180000,
});

let activeRequests = 0;

const showLoader = () => ReduxStore.dispatch(setGlobalLoading(true));
const hideLoader = () => ReduxStore.dispatch(setGlobalLoading(false));

const decreaseRequestCount = () => {
  activeRequests = Math.max(activeRequests - 1, 0);
  if (activeRequests === 0) hideLoader();
};

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    activeRequests++;
    showLoader();
    return config;
  },
  (error) => {
    decreaseRequestCount();
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    decreaseRequestCount();
    return response;
  },
  (error) => {
    decreaseRequestCount();
    console.error("API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
